/* Promo de árboles (19 al 25/10/2026). La carga el tema después de snippets/wk-promo-arboles.liquid, que antes deja
   window.WKP con: fase ('' | 'f0' | 'f1'), prevista (true en vista previa) y tote (handle real de la tote de regalo).
   0. Preparación: en vista previa, ?wkp_tote=X guarda X en sessionStorage 'wkp_tote' (con 'no' lo borra). El handle de la
      tote que se usa es ese guardado (solo en vista previa) o, si no hay, WKP.tote.
   1. Tote: lee /products/<handle>.js para saber el id de su variante y si el producto está disponible. Solo en la fase f1.
      23/10: se vuelve a leer cada poco (no una vez por página) y deja la clase wkp-tote-agotada en <html> si se ha agotado.
   2. Cesta (solo en la fase f1): si hay algún producto que no sea la tote, deja exactamente una tote (cantidad 1) marcada
      con la propiedad _wkp_regalo; si no hay otros productos, o la tote no está disponible o no existe, la quita.
      Escucha los cambios de la cesta que hace la web (fetch y XMLHttpRequest a /cart/add, change, update y clear),
      vuelve a pintar el carrito lateral y avisa con el evento 'wkp:cesta' en document.
   2b. Pagar (23/10, solo en la fase f1): antes de salir al pago desde el carrito lateral o /cart, quita la tote si se ha
      agotado (o deja solo una si hay más, o la añade si falta y queda) y envía el formulario sin las casillas updates[].
      Siempre sigue al pago.
      El "Pago express" de la ficha (assets/wk-pdp.js) también pasa por W.antesDePagar.
   3. Ocultar la tote real (en cualquier fase): en el resto de la tienda (listados, buscador...) esconde los enlaces a
      WKP.tote, nunca a la tote de vista previa. Se repite al cargar y cuando cambia el DOM, como mucho una vez por fotograma. */
(function () {
  var W = window.WKP = window.WKP || {};
  var PROPIO = 'X-WKP';
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var activa = W.fase === 'f1';

  /* Lectura y escritura de sessionStorage: si el navegador lo bloquea, no pasa nada */
  function leerSS(clave) { try { return sessionStorage.getItem(clave); } catch (e) { return null; } }
  function guardarSS(clave, valor) {
    try { if (valor === null) sessionStorage.removeItem(clave); else sessionStorage.setItem(clave, valor); } catch (e) {}
  }

  /* 0. Preparación: handle de la tote y cabecera propia para las peticiones de este script */
  if (W.prevista) {
    var consulta = new URLSearchParams(location.search), parametro = consulta.get('wkp_tote'), estadoPrueba = consulta.get('wkp_tote_estado');
    if (parametro !== null) guardarSS('wkp_tote', parametro === 'no' ? null : parametro);
    /* 23/10: ?wkp_tote_estado=hay hace creer al script que la tote de prueba queda aunque esté agotada, para probar qué pasa si
       se agota con la página abierta (cart/add contesta 422). wkp_tote_estado=no lo quita */
    if (estadoPrueba !== null) guardarSS('wkp_tote_estado', estadoPrueba === 'hay' ? 'hay' : null);
  }
  function handleTote() {
    if (W.prevista) {
      var guardado = leerSS('wkp_tote');
      if (guardado && guardado !== 'no') return guardado;
    }
    return W.tote || '';
  }
  function api(ruta, cuerpo) {
    var cab = { 'Content-Type': 'application/json', Accept: 'application/json' };
    cab[PROPIO] = '1';
    return fetch(raiz + ruta, { method: cuerpo ? 'POST' : 'GET', headers: cab, credentials: 'same-origin', cache: 'no-store', body: cuerpo ? JSON.stringify(cuerpo) : undefined })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
  }

  /* 1. Tote: id de su variante y si el producto está disponible (solo hace falta en la fase f1).
     23/10 (tote agotada): antes se leía una sola vez por página y, si se agotaba con la página abierta, el script no se enteraba
     (seguía intentando añadirla y dejaba la que hubiera en la cesta). Ahora se vuelve a leer si la lectura tiene más de un minuto
     (con cada cambio de la cesta, al volver a la pestaña y al abrir el carrito) y siempre al ir a pagar (2b). Sin caché (?wkp=hora y
     no-store): products.js sale de la caché de páginas de Shopify. Nada de mirar cada X segundos: Shopify responde 429.
     404 = la tote ya no se vende: cuenta como agotada. Error de red = no se sabe: null, y no se toca nada.
     Un 422 de cart/add al añadirla manda sobre products.js hasta cambiar de página (vetada, ver 2). */
  var lectura = null, leyendo = null, vetada = false;
  /* Clase wkp-tote-agotada de <html>: enseña la fila "Agotada" del carrito (snippets/wk-tote-agotada.liquid) y esconde la línea real
     de la tote mientras se quita. La primera la pone snippets/wk-promo-arboles.liquid con lo que sabía Shopify al pintar la página;
     aquí se confirma o se corrige con lo último que se sabe, así que nunca se contradicen */
  function marcar(agotada) {
    W.toteAgotada = agotada;
    document.documentElement.classList.toggle('wkp-tote-agotada', agotada);
  }
  function leerTote(fresca) {
    var h = handleTote();
    if (!h) return Promise.resolve(null);
    if (leyendo) return leyendo;
    if (!fresca && lectura && lectura.h === h && Date.now() - lectura.cuando < 60000) return Promise.resolve(lectura);
    leyendo = fetch(raiz + 'products/' + encodeURIComponent(h) + '.js?wkp=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (r.status === 404) return { id: null, disponible: false };
        if (!r.ok) return null;
        return r.json().then(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          return { id: v.id, disponible: !!v.available };
        });
      })
      .catch(function () { return null; })
      .then(function (t) {
        leyendo = null;
        if (!t) return null;
        if (W.prevista && t.id && leerSS('wkp_tote_estado') === 'hay') t.disponible = true;
        if (vetada) t.disponible = false;
        t.h = h;
        t.cuando = Date.now();
        lectura = t;
        marcar(!t.disponible);
        return t;
      });
    return leyendo;
  }

  /* 2. Cesta (solo en la fase f1) */
  function secciones() { return document.querySelector('cart-drawer') ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble'; }
  function pintarSecciones(resp) {
    if (!resp || !resp.sections) return;
    var cd = document.querySelector('cart-drawer');
    var abierto = cd && cd.classList.contains('active');
    if (abierto && typeof cd.renderContents === 'function') {
      cd.renderContents(resp);
    } else {
      var lector = new DOMParser();
      Object.keys(resp.sections).forEach(function (id) {
        var nuevo = lector.parseFromString(resp.sections[id] || '', 'text/html');
        if (id === 'cart-drawer') {
          var dentro = nuevo.querySelector('#CartDrawer'), actual = document.querySelector('#CartDrawer');
          if (dentro && actual) actual.innerHTML = dentro.innerHTML;
        } else {
          var caja = document.getElementById(id), sec = nuevo.querySelector('.shopify-section');
          if (caja && sec) caja.innerHTML = sec.innerHTML;
        }
      });
    }
    if (cd && typeof resp.item_count === 'number') cd.classList.toggle('is-empty', resp.item_count === 0);
  }
  /* 23/10: una línea es de tote si es su variante o si lleva la propiedad _wkp_regalo (como la reconoce el carrito en Liquid): así
     también se quita la tote de regalo si su ficha deja de existir (404) o si en vista previa se prueba con otra (?wkp_tote) */
  function esTote(t, i) { return !!((t && t.id && i.variant_id === t.id) || (i.properties && i.properties._wkp_regalo)); }
  /* 23/10: mientras este script quita o añade la tote, el carrito no admite clics (cart__items--disabled = pointer-events: none,
     component-cart.css). assets/cart.js manda la posición de la línea (line) y quitar o añadir la tote mueve las demás: hasta que
     llega el carrito nuevo, la papelera o el +/− de una prenda cambiarían otra o darían "Hubo un error al actualizar tu carrito".
     El cajón se desbloquea al volver a pintarse (es otro elemento); /cart, al recargarse. tablaVieja: en /cart la tabla no se
     vuelve a pintar, así que si la cesta cambia sin recargar (al ir a pagar), se recarga al volver a ella desde el pago (bfcache) */
  var tablaVieja = false;
  function enCarrito() { return /\/cart\/?$/.test(location.pathname); }
  function bloquear(si) {
    ['CartDrawer-CartItems', 'main-cart-items'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.toggle('cart__items--disabled', si);
    });
  }
  /* 23/10: bloquear no basta si assets/cart.js ya tiene un cambio en marcha: lo espera 300 ms antes de mandarlo, con la posición de
     la línea de antes, y si entretanto se quita o se añade la tote cambiaría otra prenda (o "Hubo un error al actualizar tu carrito").
     Pendiente = un 'change' de una casilla updates[] hace menos de 600 ms (ultimoCambio, lo apunta 2b; 600 con margen) o la clase
     cart__items--disabled, que cart.js deja hasta que llega su respuesta. Así que antes de tocar la tote se espera a que no haya
     nada pendiente y se bloquea en el acto: ya no queda ningún cambio de cart.js por salir */
  var ultimoCambio = 0;
  function cartJsPendiente() { return Date.now() - ultimoCambio < 600 || !!document.querySelector('.cart__items--disabled'); }
  /* Mira cada 50 ms hasta que pendiente() sea falso (true) o pasen max ms (false) */
  function esperarA(pendiente, max) {
    return new Promise(function (listo) {
      var desde = Date.now();
      (function mirar() {
        if (!pendiente()) listo(true);
        else if (Date.now() - desde > max) listo(false);
        else setTimeout(mirar, 50);
      })();
    });
  }
  function dormir(ms) { return new Promise(function (listo) { setTimeout(listo, ms); }); }
  function nada() {}
  /* Quita una línea de tote; con sec ({sections, sections_url}) la respuesta trae el carrito ya pintado.
     23/10: si cart/change.js falla al ponerla a 0 (en la comunidad de Shopify cuentan 422 así con el pago nuevo; aquí sin comprobar),
     se prueba con cart/update.js */
  function quitar(i, sec) {
    function cuerpo(c) { if (sec) { c.sections = sec.sections; c.sections_url = sec.sections_url; } return c; }
    return api('cart/change.js', cuerpo({ id: i.key, quantity: 0 })).catch(function () {
      var u = {};
      u[i.key] = 0;
      return api('cart/update.js', cuerpo({ updates: u }));
    });
  }
  /* Rápido (16/10): sin esperar casi nada, aprovechando la cesta que ya devuelve Shopify al cambiarla (cart/change y cart/update)
     y pidiendo el carrito ya pintado en la misma petición que añade o quita la tote (sin la vuelta extra a cart/update). */
  var ocupado = false, otraVez = false, datosPendientes = null;
  /* Qué le falta a la cesta (null si ya está bien): deTote = sus líneas de tote, quiere = cuántas totes debe llevar (0 o 1) y
     buena = hay una sola línea de tote y es la de regalo */
  function revisar(t, cart) {
    var deTote = cart.items.filter(function (i) { return esTote(t, i); });
    var otras = cart.items.filter(function (i) { return !esTote(t, i); });
    var cant = deTote.reduce(function (s, i) { return s + i.quantity; }, 0);
    var quiere = t.disponible && otras.length > 0 ? 1 : 0;
    var buena = deTote.length === 1 && deTote[0].variant_id === t.id && !!(deTote[0].properties && deTote[0].properties._wkp_regalo);
    if (cant === quiere && (quiere === 0 || buena)) return null;
    return { deTote: deTote, quiere: quiere, buena: buena };
  }
  function sincronizar(datos) {
    if (!activa || W.pagando) return;  /* 23/10: mientras se sale al pago no se toca la cesta (2b) */
    if (ocupado) { otraVez = true; datosPendientes = null; return; }
    ocupado = true;
    var bloqueado = false;
    leerTote(false).then(function (t) {
      if (!t) return false;  /* No se sabe si queda (error de red): no se toca nada */
      var cesta = datos && datos.items ? Promise.resolve(datos) : api('cart.js');
      return cesta.then(function (cart) {
        if (!revisar(t, cart)) return false;
        /* 23/10: antes de tocar la tote, que assets/cart.js no tenga nada pendiente (ver cartJsPendiente) y bloqueo en el acto. Si ha
           habido que esperar, la cesta ha cambiado: se vuelve a leer ya bloqueada. Si tras 4 s sigue ocupado, no se toca nada (la
           respuesta de cart.js vuelve a llamar a sincronizar) y tampoco si entretanto se ha pulsado "Pagar" (2b se encarga) */
        var libre = !cartJsPendiente();
        return (libre ? Promise.resolve(true) : esperarA(cartJsPendiente, 4000)).then(function (ok) {
          if (!ok || W.pagando) return null;
          bloqueado = true;
          bloquear(true);
          return libre ? cart : api('cart.js');
        }).then(function (cart2) {
          var falta = cart2 && revisar(t, cart2);
          if (!falta) return false;
          var deTote = falta.deTote, quiere = falta.quiere, buena = falta.buena;
          var sec = { sections: secciones(), sections_url: location.pathname };
          function cambiar(i, cantidad, conSecciones) {
            var c = { id: i.key, quantity: cantidad };
            if (conSecciones) { c.sections = sec.sections; c.sections_url = sec.sections_url; }
            return api('cart/change.js', c);
          }
          var paso = Promise.resolve(null);
          if (quiere && buena) {
            /* Solo sobra cantidad: se deja en 1 */
            paso = cambiar(deTote[0], 1, true);
          } else {
            /* Fuera todas las líneas de tote; la última petición trae el carrito pintado (23/10: siempre, por si luego no se puede añadir) */
            deTote.forEach(function (i, n) {
              paso = paso.then(function () { return quitar(i, n === deTote.length - 1 ? sec : null); });
            });
            if (quiere) paso = paso.then(function (quitada) {
              return api('cart/add.js', { items: [{ id: t.id, quantity: 1, properties: { _wkp_regalo: '1' } }], sections: sec.sections, sections_url: sec.sections_url })
                .catch(function (r) {
                  /* 23/10: 422 = no se puede añadir porque se ha agotado (con cantidad 1 no hay "solo se añadieron N"). Antes el error se
                     perdía y se volvía a intentar con cada cambio. Ahora cuenta como agotada hasta cambiar de página, diga lo que diga
                     products.js, y se enseña la fila de aviso. Se devuelve el carrito de la última tote quitada; si no se quitó ninguna,
                     nada: la cesta no ha cambiado y la fila ya está pintada, solo faltaba la clase */
                  if (!r || r.status !== 422) throw r;
                  vetada = true;
                  if (lectura) lectura.disponible = false;
                  marcar(true);
                  return quitada;
                });
            });
          }
          return paso.then(function (resp) {
            if (!resp) return false;
            pintarSecciones(resp);
            var cd = document.querySelector('cart-drawer');
            if (cd && quiere) cd.classList.remove('is-empty');
            document.dispatchEvent(new CustomEvent('wkp:cesta', { detail: resp }));
            return true;
          });
        });
      });
    }).then(function (cambio) {
      /* En la página /cart no hay carrito lateral: se recarga una vez para que salga la tote (o deje de salir).
         23/10: nunca mientras se sale al pago (cortaría el envío del formulario); entonces la tabla queda vieja (ver bloquear) y
         bloqueada: sus posiciones de línea ya no valen */
      if (cambio && enCarrito()) {
        if (!W.pagando) { location.reload(); return; }
        tablaVieja = true;
        return;
      }
      if (bloqueado) bloquear(false);
    }).catch(function () { if (bloqueado) bloquear(false); }).then(function () {
      ocupado = false;
      if (otraVez) { otraVez = false; sincronizar(datosPendientes); datosPendientes = null; }
    });
  }
  W.sincronizar = sincronizar;
  var RUTA_CESTA = /\/cart\/(add|change|update|clear)/;
  /* 23/10: porMirar = cambios de la cesta de la web cuya respuesta aún no ha llegado a trasCambio; temporizador = sincronización
     ya pedida que aún no ha empezado. Antes de pagar (2b) se espera por los dos: el "Pago express" de la ficha sale al pago justo
     después de su cart/add y así le da tiempo a la cesta a ponerse al día (añadir la tote de regalo) */
  var temporizador = 0, porMirar = 0;
  function trasCambio(datos) { clearTimeout(temporizador); temporizador = setTimeout(function () { temporizador = 0; sincronizar(datos); }, 50); }
  if (activa) {
    var fetchOriginal = window.fetch;
    window.fetch = function (entrada, opciones) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var cab = opciones && opciones.headers, propio = false;
      if (cab) propio = typeof cab.get === 'function' ? !!cab.get(PROPIO) : !!cab[PROPIO];
      var p = fetchOriginal.apply(this, arguments);
      if (!propio && RUTA_CESTA.test(url)) {
        /* Se lee una copia de la respuesta (antes que el tema): si trae la cesta entera, no hace falta volver a pedirla */
        porMirar++;
        var mirada = function (d) { porMirar--; trasCambio(d); };
        p.then(function (r) {
          var copia;
          try { copia = r.clone(); } catch (e) { mirada(null); return; }
          copia.json().then(function (j) { mirada(j && j.items && typeof j.item_count === 'number' ? j : null); }, function () { mirada(null); });
        }, function () { porMirar--; });
      }
      return p;
    };
    var abrirXhr = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (metodo, url) {
      if (RUTA_CESTA.test(String(url))) this.addEventListener('load', function () { trasCambio(null); });
      return abrirXhr.apply(this, arguments);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sincronizar(null); }); else sincronizar(null);
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      /* 23/10: al volver atrás desde el pago la página vuelve tal cual: botón de pago y casillas como estaban antes de pagar (2b).
         En /cart, si la cesta cambió al ir a pagar, la tabla tiene posiciones de línea viejas: se recarga */
      if (tablaVieja && enCarrito()) { location.reload(); return; }
      restaurarPago();
      sincronizar(null);
    });
    /* 23/10: si la última lectura de la tote tiene más de un minuto, se repasa al volver a la pestaña y al abrir el carrito */
    var repasar = function () { if (!lectura || Date.now() - lectura.cuando >= 60000) sincronizar(null); };
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') repasar(); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#cart-icon-bubble')) repasar(); }, true);
  }

  /* 2b. Pagar (23/10, tote agotada; solo en la fase f1). Los dos botones de pago, #CartDrawer-Checkout (snippets/cart-drawer.liquid)
     y #checkout (sections/main-cart-footer.liquid), envían su formulario a /cart con name=checkout y Shopify salta al pago.
     Antes de dejarlo ir (antesDePagar): se espera a que se guarden los cambios de cantidad pendientes, se lee la cesta y, si lleva
     tote (o lleva otras prendas sin ella), se mira sin caché si queda; si se ha agotado (o ya no hay otro producto) se quita, si
     queda pero hay más de una, se deja una, y si falta y queda, se añade (23/10, revisión: "Pagar" pulsado antes de que 2 la
     añadiera; mientras se paga, 2 no toca la cesta). Luego se reenvía el mismo formulario con el mismo botón (requestSubmit): se conservan la nota de /cart y los campos de
     las apps (#cr-pickup-after).
     Siempre sigue al pago, también si la tote se acaba de agotar (sale sin ella, que es lo que se busca; el cajón ya enseña la fila
     "Agotada" si se vuelve atrás). Nunca se bloquea la compra: unos 6,5 s como mucho, con el botón en espera, y si algo falla sigue
     igual (en el pago, Shopify quita lo que no tenga stock).
     Sin las casillas updates[]: Shopify las aplica por posición, en el orden de la cesta. Hasta el 23/10 el carrito las pintaba en
     otro (la tote al final) y se cruzaban las cantidades (tote + camiseta x2 llegaba al pago como 2 totes y 1 camiseta); ese día el
     carrito pasó a una sola pasada, en el orden de la cesta, y aquí se quitan igual por si acaso. Las cantidades ya están guardadas:
     assets/cart.js las manda a cart/change en cuanto cambian.
     El "Pago express" de la ficha (assets/wk-pdp.js) usa W.antesDePagar antes de ir al pago. No pasan por aquí los botones de pago
     exprés de Shopify de /cart (Shop Pay, Apple Pay...; el cajón no los tiene) ni los enlaces directos al pago: para ellos, la tote
     agotada se quita en cuanto se sabe (2) y, si aun así llega una que se acaba de agotar, el pago de Shopify la quita con un aviso.
     No se esconden esos botones (lo propuso la revisión del 23/10): se perderían durante toda la promo por un caso de segundos. */
  W.pagando = false;
  var pasando = false;
  function cargando(b, si) {
    if (!b) return;
    b.classList.toggle('wkp-pagando', si);
    if (si) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
  }
  /* Deja el pago como antes de pulsar el botón: al volver atrás desde el pago (bfcache, en 2) y, a los 6 s, si la página no llega
     a salir (un aviso del formulario, una app que cancela el envío...). Vuelven las casillas updates[] y se quita el name=checkout
     puesto a mano (enviar). El carrito se desbloquea; la tabla vieja de /cart (sus posiciones de línea ya no valen), al volver a
     pintarse (repintarTabla) */
  var respaldo = 0;
  /* 23/10 (revisión): en /cart, si la cesta cambió al ir a pagar y la página no llega a salir, antes la tabla se quedaba bloqueada
     hasta recargar a mano. Ahora se vuelve a pintar con la cesta de ahora, como hace assets/cart.js tras un cambio (mismas secciones:
     tabla, burbuja y subtotal), y se desbloquea. Sin recargar: si el pago solo va lento, una recarga lo cortaría, y si una app ha
     parado el envío, se perdería lo que se esté rellenando. Si algo falla o la cesta se ha quedado vacía, se recarga */
  function repintarTabla() {
    var ci = document.querySelector('cart-items');
    if (!ci || typeof ci.getSectionsToRender !== 'function' || typeof ci.getSectionInnerHTML !== 'function') { location.reload(); return; }
    var lista = ci.getSectionsToRender();
    fetch(raiz + 'cart?sections=' + lista.map(function (s) { return s.section; }).join(','), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (secs) {
        lista.forEach(function (s) {
          var caja = document.getElementById(s.id);
          if (!caja) return;
          (caja.querySelector(s.selector) || caja).innerHTML = ci.getSectionInnerHTML(secs[s.section], s.selector);
        });
        if (!document.querySelector('#main-cart-items tr.cart-item')) { location.reload(); return; }
        tablaVieja = false;
        bloquear(false);
      })
      .catch(function () { location.reload(); });
  }
  function restaurarPago() {
    clearTimeout(respaldo);
    W.pagando = false;
    if (tablaVieja && enCarrito()) repintarTabla(); else bloquear(false);
    cargando(document.getElementById('CartDrawer-Checkout'), false);
    cargando(document.getElementById('checkout'), false);
    Array.prototype.forEach.call(document.querySelectorAll('[data-wkp-fuera]'), function (c) {
      if (c.getAttribute('data-wkp-fuera') === 'checkout') { if (c.parentNode) c.parentNode.removeChild(c); return; }
      c.disabled = false;
      c.removeAttribute('data-wkp-fuera');
    });
  }
  /* Cambios pendientes: los de assets/cart.js (cartJsPendiente, en 2) y la sincronización de la tote (2), si está en marcha o pedida
     (porMirar, temporizador). Como mucho 1,5 s (de sobra para los 300 ms de cart.js y su respuesta); el tope de lo que sigue va aparte */
  function esperarCesta() {
    return esperarA(function () { return cartJsPendiente() || ocupado || porMirar > 0 || temporizador; }, 1500);
  }
  /* 23/10 (revisión): el tiempo va por fases, cada una con su tope, para que la espera no se coma la comprobación:
     1. esperarCesta: 1,5 s como mucho.
     2. Con el carrito bloqueado (que un +/− no se cruce con la retirada, ver cartJsPendiente), se lee la cesta y, si lleva tote (o
        lleva otras prendas sin ella), la tote sin caché. Agotada (o sin otro producto): fuera. Queda pero hay más de una (dos pestañas que la añaden a la vez y la cesta
        las junta en una línea x2; sincronizar no corrige nada mientras se sale al pago): se deja una. Sin tote pero con otras
        prendas y queda: se añade, solo si no hay ninguna sincronización en marcha ni pedida (si la hay, la añade ella; así no
        acaban dos en la cesta). 3 s como mucho; pasado ese tiempo ya no se empieza a tocar la cesta.
     3. Si ya se estaba tocando, se espera a que acabe (2 s como mucho), para que el envío al pago no se adelante a la retirada.
     Nunca falla: siempre se cumple, como mucho en unos 6,5 s. Al acabar desbloquea el carrito (salvo la tabla vieja de /cart) */
  function antesDePagar() {
    var tarde = false, cambio = null;
    return esperarCesta().then(function (limpio) {
      bloquear(true);
      var revision = api('cart.js').then(function (cart) {
        var conTote = cart.items.some(function (i) { return esTote(lectura, i); });
        if (tarde || !cart.items.length || (!conTote && (!activa || vetada))) return;
        return leerTote(true).then(function (t) {
          if (tarde) return;
          var deTote = cart.items.filter(function (i) { return esTote(t || lectura, i); });
          var otras = cart.items.length - deTote.length;
          var fuera = deTote, deja = null;
          var sec = { sections: secciones(), sections_url: location.pathname };
          if (!deTote.length) {
            /* 23/10 (revisión): sin tote. Si queda y no hay ninguna sincronización en marcha ni pedida, se añade aquí como en 2 (si
               no, se paga tal cual). 422 = se acaba de agotar: igual que en 2, cuenta como agotada y sale la fila de aviso */
            if (!t || !t.id || !t.disponible || !limpio || ocupado || temporizador || porMirar > 0) return;
            if (enCarrito()) tablaVieja = true;
            cambio = api('cart/add.js', { items: [{ id: t.id, quantity: 1, properties: { _wkp_regalo: '1' } }], sections: sec.sections, sections_url: sec.sections_url })
              .then(pintarSecciones, function (r) {
                if (!r || r.status !== 422) return;
                vetada = true;
                if (lectura) lectura.disponible = false;
                marcar(true);
              });
            return cambio;
          }
          if (otras && !t) return;  /* No se sabe si queda: se paga tal cual */
          if (otras && t.disponible) {
            deja = deTote.filter(function (i) { return i.variant_id === t.id && i.properties && i.properties._wkp_regalo; })[0] || null;
            if (!deja || (deTote.length === 1 && deja.quantity === 1)) return;  /* Queda y está bien: se paga con ella */
            fuera = deTote.filter(function (i) { return i !== deja; });
          }
          var pasos = fuera.map(function (i) { return function (s) { return quitar(i, s); }; });
          if (deja && deja.quantity > 1) pasos.push(function (s) {
            var c = { id: deja.key, quantity: 1 };
            if (s) { c.sections = s.sections; c.sections_url = s.sections_url; }
            return api('cart/change.js', c);
          });
          if (enCarrito()) tablaVieja = true;
          var paso = Promise.resolve(null);
          pasos.forEach(function (p, n) {
            paso = paso.then(function () { return p(n === pasos.length - 1 ? sec : null); });
          });
          cambio = paso.then(pintarSecciones);
          return cambio;
        });
      });
      return Promise.race([revision, dormir(3000)]);
    }).then(nada, nada).then(function () {
      tarde = true;
      return cambio && Promise.race([cambio, dormir(2000)]);
    }).then(nada, nada).then(function () {
      if (!(tablaVieja && enCarrito())) bloquear(false);
    });
  }
  W.antesDePagar = antesDePagar;
  function enviar(f, b) {
    Array.prototype.forEach.call(f.elements, function (c) {
      if (c.name === 'updates[]') { c.disabled = true; c.setAttribute('data-wkp-fuera', ''); }
    });
    var conBoton = b && b.form === f && !b.disabled && typeof f.requestSubmit === 'function';
    if (!conBoton) {
      /* Sin el botón (o navegador sin requestSubmit): name=checkout a mano, como hace el propio tema para Internet Explorer */
      var c = document.createElement('input');
      c.type = 'hidden';
      c.name = 'checkout';
      c.setAttribute('data-wkp-fuera', 'checkout');  /* restaurarPago la quita */
      f.appendChild(c);
    }
    pasando = true;  /* El submit que sigue es de este script: que no se vuelva a parar */
    try {
      if (conBoton) f.requestSubmit(b);
      else if (typeof f.requestSubmit === 'function') f.requestSubmit();
      else HTMLFormElement.prototype.submit.call(f);
    } finally {
      pasando = false;
    }
  }
  if (activa) {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'updates[]') ultimoCambio = Date.now();
    }, true);
    /* En captura y con 'submit' (no con el clic): así también se para Enter en una cantidad, que envía el formulario al pago */
    document.addEventListener('submit', function (e) {
      /* El id con getAttribute: form.id devolvería la casilla si alguna app mete una con name="id" */
      var f = e.target, b = e.submitter, idForm = f && f.getAttribute && f.getAttribute('id');
      if (pasando || (idForm !== 'CartDrawer-Form' && idForm !== 'cart')) return;
      if (b && b.getAttribute('name') !== 'checkout') return;  /* Sin submitter (navegadores viejos) también va al pago: es el único botón de envío */
      e.preventDefault();
      if (W.pagando) return;  /* Doble clic */
      W.pagando = true;
      var idBoton = (b && b.id) || (idForm === 'cart' ? 'checkout' : 'CartDrawer-Checkout');
      cargando(document.getElementById(idBoton), true);
      /* Si se estaba escribiendo una cantidad, se suelta la casilla: salta su 'change' y assets/cart.js la guarda antes de pagar */
      var activo = document.activeElement;
      if (activo && activo.name === 'updates[]' && activo.blur) activo.blur();
      /* 23/10 (revisión): antesDePagar se corta sola (unos 6,5 s como mucho); estos 8 s son solo una red por si algo se tuerce */
      var hecho = false, tope = setTimeout(seguir, 8000);
      function seguir() {
        if (hecho) return;
        hecho = true;
        clearTimeout(tope);
        /* Por id otra vez: al quitar la tote o al guardar una cantidad se vuelve a pintar el carrito y los de antes ya no están */
        var f2 = document.getElementById(idForm), b2 = document.getElementById(idBoton);
        if (!f2) { W.pagando = false; return; }
        cargando(b2, true);
        enviar(f2, b2);
        /* Si el navegador no sale de la página (un aviso del formulario, una app...), el botón y las casillas vuelven a funcionar */
        clearTimeout(respaldo);
        respaldo = setTimeout(restaurarPago, 6000);
      }
      /* 23/10 (revisión): siempre al pago, también si la tote se acaba de agotar: ya no está en la cesta y el pago sale sin ella */
      antesDePagar().then(seguir, seguir);
    }, true);
  }

  /* 3. Ocultar la tote real (WKP.tote) en el resto de la tienda, en cualquier fase.
     Los enlaces dentro de la cesta no se tocan: ahí la tote sí tiene que verse. */
  var FUERA_DE_OCULTAR = 'cart-drawer-items, #main-cart-items, .cart-items, .cart-notification';
  /* Solo contenedores de tarjeta (nunca un <li> cualquiera: en el menú del móvil las tarjetas de "Lo más deseado" van sueltas
     dentro de la opción del menú y se escondería la opción entera). .wkn-c = complementos del carrito; .wkdm__c = "Lo más deseado" */
  var CAJAS = '.grid__item, .card-wrapper, .predictive-search__list-item, .swiper-slide, .slider__slide, .wkn-c, .wkdm__c';
  /* Nombre exacto: /products/<handle> seguido de /, ?, # o fin (no esconde otro producto cuyo handle empiece igual) */
  var reTote = W.tote ? new RegExp('/products/' + W.tote + '(?:[/?#]|$)') : null;  /* los handle de Shopify solo llevan a-z, 0-9 y guiones */
  function ocultar() {
    if (!W.tote) return;
    var enlaces = document.querySelectorAll('a[href*="/products/' + W.tote + '"]');
    for (var i = 0; i < enlaces.length; i++) {
      var enlace = enlaces[i];
      if (!reTote.test(enlace.getAttribute('href') || '')) continue;
      if (enlace.closest(FUERA_DE_OCULTAR)) continue;
      var contenedor = enlace.closest(CAJAS) || enlace;
      contenedor.style.display = 'none';
      contenedor.setAttribute('data-wkp-oculto', '1');
    }
  }
  var marcoOculto = 0;
  function ocultarEnFotograma() {
    if (marcoOculto) return;
    marcoOculto = requestAnimationFrame(function () { marcoOculto = 0; ocultar(); });
  }
  document.addEventListener('DOMContentLoaded', ocultar);
  ocultar();
  new MutationObserver(ocultarEnFotograma).observe(document.documentElement, { childList: true, subtree: true });
})();
